import { createSelector } from "@ngrx/store";

import { IAppState } from "../state/app.state";
import { ILayoutState } from "@edp-store/state/layout.state";

const layoutSelector = (state: IAppState) => state.layout;

export const getShowSidebar = createSelector(layoutSelector, (state: ILayoutState) => {
    return {
        showSidebar: state.showSidebar,
        needLoadUserPoints: state.needLoadUserPoints,
    };
});

export const getShowSidebarSublevel = createSelector(
    layoutSelector,
    (state: ILayoutState) => state.openSublevel
);

export const getSelectOverlay = createSelector(
    layoutSelector,
    (state: ILayoutState) => state.selectOverlay
);

export const getSelectSidebarSublevel = createSelector(
    layoutSelector,
    (state: ILayoutState) => state.selectSidebarSublevel
);

export const getActiveItemSidebar = createSelector(
    layoutSelector,
    (state: ILayoutState) => state.activeItemSidebar
);

export const getMainMenu = createSelector(
    layoutSelector,
    (state: ILayoutState) => state.mainMenu
);

export const getActiveTabMenu = createSelector(
    layoutSelector,
    (state: ILayoutState) => state.tabMenu
);

export const showLoader = createSelector(
    (state: IAppState) => {
        return state.layout.loaderCount;
    },
    (loaderCount: number) => loaderCount > 0
);

export const getLastActiveRoute = createSelector(
    layoutSelector,
    (state: ILayoutState) => state.lastActiveRoute
);

export const lastResponse = createSelector(
    layoutSelector,
    (state: ILayoutState) => state.lastResponse
);

export const getShowHeaderAlert = createSelector(
    layoutSelector,
    (state: ILayoutState) => state.showAlert
);
